import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
declare module 'vue/types/vue' {
    interface Vue {
        readonly COUPON_STATUS: {[key: string]: number};
        readonly COUPON_INSTANCE_STATUS: {[key: string]: number};
    }
}
@Component
export default class CouponStatus extends Vue {
    public data() {
        return {
            COUPON_STATUS: {
                'COUPON_CANNOT_REDEEM': 3001,
                'COUPON_OUT_OF_REDEEM_TIME_RANGE': 3002,
                'COUPON_HAS_BEEN_REDEEMED': 3003,
                'COUPON_OUT_OF_STOCK': 3004,
                'COUPON_HAS_EXPIRED': 3005,
                'COUPON_INS_DOES_NOT_BELONG': 3101,
                'COUPON_INS_INACTIVE': 3102,
                'COUPON_INS_HAS_EXPIRED': 3102,
            },
            COUPON_INSTANCE_STATUS: {
                'UNPAID': -1,
                'READY_TO_USE': 0,
                'USED': 1,
                'EXPIRED': 2,
                'REFUNDED': 3,
                'DISCARDED': 4
            }
        };
    }
}

